// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabletable-container{
    display: flex;
    padding-left: 200px;
}
.demadmin-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    justify-content: space-between; 
    /* background-color: #eaecf8; */
     /*page background color*/
     background-color: #fffef7;
    /* it will give space between header and footer */
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    }   `, "",{"version":3,"sources":["webpack://./src/assets/css/BdmAdminTabledetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,8BAA8B;IAC9B,+BAA+B;KAC9B,wBAAwB;KACxB,yBAAyB;IAC1B,iDAAiD;EACnD;EACA;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB","sourcesContent":[".tabletable-container{\r\n    display: flex;\r\n    padding-left: 200px;\r\n}\r\n.demadmin-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100vh;\r\n    justify-content: space-between; \r\n    /* background-color: #eaecf8; */\r\n     /*page background color*/\r\n     background-color: #fffef7;\r\n    /* it will give space between header and footer */\r\n  }\r\n  * {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n    }   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
